import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Eyebrow, SerifH } from "./shared";

export function Newsletter() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  return (
    <section
      id="newsletter"
      data-testid="newsletter"
      className="bg-[#0C111C] text-[#F4EDE2] border-t border-white/10"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20 py-24 md:py-32 text-center">
        <Eyebrow>Join the atelier</Eyebrow>
        <SerifH className="mt-4 text-[#F4EDE2]" size="clamp(36px, 4.4vw, 72px)">
          Limited prints.
          <br /> Early access.
        </SerifH>
        <p
          className="mt-5 text-base md:text-lg text-[#F4EDE2]/80 max-w-md mx-auto"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          Get 10% off your first order + first look at every drop.
        </p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (email) setSent(true);
          }}
          data-testid="newsletter-form"
          className="mt-10 mx-auto max-w-lg flex flex-col sm:flex-row items-stretch gap-3"
        >
          <input
            data-testid="newsletter-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@yaba.com"
            className="flex-1 rounded-full bg-transparent border border-[#F4EDE2]/30 px-6 py-4 text-[#F4EDE2] placeholder:text-[#F4EDE2]/40 focus:outline-none focus:border-[#C8A96A]"
            style={{ fontFamily: "Inter, sans-serif" }}
          />
          <button
            data-testid="newsletter-submit"
            type="submit"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-[#C8A96A] text-[#0C111C] px-8 py-4 font-medium hover:bg-[#F4EDE2] transition-colors"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            Join the atelier <ArrowRight size={16} />
          </button>
        </form>
        <AnimatePresence>
          {sent && (
            <motion.p
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              className="mt-5 text-sm text-[#C8A96A]"
              style={{ fontFamily: "Inter, sans-serif" }}
            >
              Thank you — check your inbox for your 10% code.
            </motion.p>
          )}
        </AnimatePresence>
        <p
          className="mt-4 text-[11px] tracking-[0.16em] uppercase text-[#F4EDE2]/40"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          No spam. Unsubscribe in one click.
        </p>
      </div>
    </section>
  );
}
